import ko from 'knockout';
import moment from 'moment';
import 'moment/locale/da';
import 'moment/locale/de';

export function registerComponent() {
  ko.components.register('search-arrival-picker', {
    template: { element: 'search-arrival-picker-template' },
    viewModel: { createViewModel: function (params, componentInfo) { return new SearchArrivalPickerViewModel(params, componentInfo); } }
  });
}

function SearchArrivalPickerViewModel(params, componentInfo) {
  var self = this;
  var $component = $(componentInfo.element);
  $component.change(function (event) {
    event.stopPropagation();
  });

  self.currentStartDate = params.init.startDate;

  var currentMonth = moment().add(1, 'day').toDate();
  currentMonth.setDate(1);

  // -- Observables definitions and their subscribers --
  // These are the internal start and end dates. They are copied in searchPeriodPickerData when Apply is clicked.
  self.startDate = ko.observable(null);
  self.duration = ko.observable(null);
  self.currentMonth = ko.observable(currentMonth);

  self.arrivalPickerHeader = ko.observable('<i>' + params.init.texts['Choose arrival'] + '</i>');
  self.minDate = ko.observable(moment().toDate());
  self.maxDate = ko.observable(new Date(new Date().getFullYear() + 1, 12 - 1, 31));
  //self.maxDate = ko.observable(moment().add(500, 'days').toDate());

  self.apply = apply;
  self.cancel = cancel;
  self.searchWithoutPeriod = searchWithoutPeriod;

  // -- Subscribers --
  self.currentStartDate.subscribe(function () {
    setLabelText();
  });

  self.startDate.subscribe(function startDateChanged() {
    updateHeadline();
    if (self.startDate() !== null) {
      var startDate = moment(self.startDate()).format('DD-MM-YYYY');
      if (startDate !== self.currentStartDate()) {
        apply();
      }
    }
  });

  // -- Add dropdown-popup event handlers --
  params.events.onOpen(function onSearchPeriodPickerOpen() {
    var currentStartDate = self.currentStartDate() === '' ? null : moment(self.currentStartDate(), 'DD-MM-YYYY').toDate();
    self.startDate(currentStartDate);

    var currentMonth;
    // If startDate is already set, then open the calendar at that month instead of the current month.
    if (currentStartDate === null) {
      currentMonth = moment().add(1, 'day').toDate();
    }
    else {
      currentMonth = new Date(currentStartDate.getTime());
    }
    currentMonth.setDate(1); // Set the date to 1st day of month, so the navigation through months wouldn't mess up the date object if the day is set to 31 and the next/previous month has 30 days. Setting day 31 on a month with 30 days would increase the month by 1 and set the day to 1 automatically.
    self.currentMonth(currentMonth);
  });

  params.events.onClose(function onSearchPeriodPickerClose() {
    self.apply();
  });

  // -- Initialization --
  setLabelText();
  updateHeadline();

  // -- Function definitions --
  function updateHeadline() {
    var format = "dddd, D.M.YYYY";
    var startDate = self.startDate();

    if (!startDate) {
      self.arrivalPickerHeader('<i>' + params.init.texts['Choose arrival'] + '</i>');
    }
    else {
      self.arrivalPickerHeader(moment(startDate).format(format));
    }
  }

  /**
   * Sets the label text that's displayed when the dropdown-popup is closed.
   */
  function setLabelText() {
    var currentStartDate = self.currentStartDate() === '' ? null : moment(self.currentStartDate(), 'DD-MM-YYYY').toDate();

    if (currentStartDate !== null) {
      var momentStartDate = moment(currentStartDate);
      params.helpers.label(momentStartDate.format('dd, D.M'));
    }
    else {
      params.helpers.label(params.init.texts['Choose arrival']);
    }
  }

  function apply() {
    if (self.startDate() !== null) {
      var startDate = moment(self.startDate()).format('DD-MM-YYYY');

      setArrival(startDate);
      params.helpers.closeImmediately();
    }
  }

  function cancel() {
    params.helpers.closeImmediately();
  }

  function searchWithoutPeriod() {
    setArrival('');
    params.helpers.closeImmediately();
    return false;
  }

  function setArrival(startDate) {
    if (startDate !== self.currentStartDate()) {
      self.currentStartDate(startDate);
      $(componentInfo.element).trigger('arrivalselected');
    }
  }
}